import { render, staticRenderFns } from "./ThemeSettingsDirect.vue?vue&type=template&id=5e3096ee&scoped=true"
import script from "./ThemeSettingsDirect.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3096ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e3096ee')) {
      api.createRecord('5e3096ee', component.options)
    } else {
      api.reload('5e3096ee', component.options)
    }
    module.hot.accept("./ThemeSettingsDirect.vue?vue&type=template&id=5e3096ee&scoped=true", function () {
      api.rerender('5e3096ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/themes/ThemeSettingsDirect.vue"
export default component.exports